var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19189,
    y: 1.40918,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#1859B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.19189,
    y: 1.40918,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2827 10.4941C20.4682 10.3087 20.6883 10.1616 20.9306 10.0612C21.1729 9.96083 21.4326 9.90918 21.6949 9.90918C21.9571 9.90918 22.2168 9.96083 22.4591 10.0612C22.7014 10.1616 22.9215 10.3087 23.107 10.4941C23.2924 10.6795 23.4395 10.8997 23.5399 11.142C23.6402 11.3843 23.6919 11.644 23.6919 11.9062C23.6919 12.1685 23.6402 12.4282 23.5399 12.6704C23.4395 12.9127 23.2924 13.1329 23.107 13.3183L13.5752 22.8501L9.69189 23.9092L10.751 20.0259L20.2827 10.4941Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/EditPen.47036a697ccc21839ce0c83c4667af46.svg";
export { ForwardRef as ReactComponent };